import React from "react";
// import logo from '../../assets/images/logo_lf_skane.svg';
import logo from '../../assets/icons/symbol_lansforsakringar.svg';

export default class FooterBottom extends React.Component {

    render() {
        return (
            <footer className="mt-5">
                <div className="lf-footer">
                    <ul className="ul lf-footer-link-list reset-list">
                        {/*<button className="btn btn-outline-secondary">*/}
                        {/*    <svg role="presentation" className="icon icon-nudge-up-01 text-red mr-03" width="20"*/}
                        {/*         height="20">*/}
                        {/*        /!*<use xlink:href="#icon-heart-20"></use>*!/*/}
                        {/*    </svg>*/}
                        {/*    Tyck till*/}
                        {/*</button>*/}
                        <li><a href="https://www.lansforsakringar.se/skane/privat/om-oss/kontakta-oss/sidfot/personuppgifter/"
                               target="" className="link-adaptive">Personuppgifter</a></li>
                        <li><a href="https://www.lansforsakringar.se/skane/privat/om-oss/kontakta-oss/sidfot/cookies/" target="" className="link-adaptive">Cookies</a></li>
                        <li><a href="https://www.lansforsakringar.se/skane/privat/om-oss/kontakta-oss/sidfot/anvandarvillkor/" target="blank" className="link-adaptive">Användarvillkor</a></li>
                        <li><a href="https://www.lansforsakringar.se/skane/privat/om-oss/kontakta-oss/" target="blank" className="link-adaptive">Kontakta oss</a></li>
                        <li><a href="https://www.lansforsakringar.se/skane/privat/om-oss/kontakta-oss/sidfot/residents-in-the-u.s/" target="blank" className="link-adaptive">Residents in the U.S.</a></li>
                    </ul>
                    <div className="lf-footer-logo">
                        <img src={logo} width="100%"/>
                    </div>
                </div>
            </footer>
        );
    }
}
